import { createAction, props } from '@ngrx/store';

export const setShowAddressChangePopup = createAction(
  '[Popup Notifications] Set show address change popup',
  props<{ showAddressChangePopup: boolean }>()
);
